import React from 'react';
import type { SkeletonProps } from '@features/server-ui';
import { Box, Skeleton } from '@mui/material';

const ROW_COUNT = 4;

export const SkeletonRow: React.FC = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      py: 1,
      borderBottom: '1px solid',
      borderColor: 'divider',
      '&:last-child': { borderBottom: 'none' },
    }}
  >
    <Skeleton variant="circular" sx={{width: 8, height: 8,  flexShrink: 0 }} />
    <Skeleton variant="text" sx={{ flex: 1, fontSize: '0.875rem' }} />
    <Skeleton variant="text" sx={{width: 48,  flexShrink: 0, fontSize: '0.75rem' }} />
  </Box>
);

export const HistoryListSkeleton: React.FC<SkeletonProps> = () => (
  <Box>
    <Skeleton variant="text" sx={{width: 80, height: 28,  mb: 0.5 }} />
    {Array.from({ length: ROW_COUNT }, (_, i) => (
      <SkeletonRow key={i} />
    ))}
  </Box>
);
